module.exports = __webpack_public_path__ + "img/paypal.95182bba.svg";